import { withStyles } from '@material-ui/core/styles';
import LoginFromLandingPage from './LoginFromLandingPage';

const styles = () => ({
  formContainer: {
    height: 'auto',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default withStyles(styles)(LoginFromLandingPage);
